"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  HUB_MARKETING: 'marketing',
  HUB_SALES: 'sales',
  HUB_SERVICE: 'service',
  HUB_CMS: 'cmsHub'
};
exports.default = _default;
module.exports = exports.default;